export default __webpack_public_path__ + "static/media/CheckWhite.44ebac63.svg";